import YYInputNumber from './input-number'

export default YYInputNumber